import { Precision as _Precision } from "./Precision";
export class Fixed {
    value;
    precision;
    constructor(value, precision = 0) {
        this.value = value;
        this.precision = precision;
    }
    create(value, precision = this.precision) {
        return new Fixed(value, precision).round();
    }
    round(precision = this.precision) {
        const factor = Math.pow(10, precision);
        const decimals = (this.value.toString().split(".")?.[1]?.length ?? 0) - 1;
        return new Fixed(Math.round((this.value + (decimals <= precision + 5 ? Number.EPSILON : Math.pow(10, -decimals))) * factor) /
            factor, precision);
    }
    add(term) {
        return this.create(this.value + (typeof term == "number" ? this.create(term) : term).value);
    }
    subtract(minuend) {
        return this.create(this.value - (typeof minuend == "number" ? this.create(minuend) : minuend).value);
    }
    multiply(multiplicand) {
        return this.create(this.value * (typeof multiplicand == "number" ? multiplicand : multiplicand.value));
    }
    divide(denominator) {
        return this.create(this.value / (typeof denominator == "number" ? denominator : denominator.value));
    }
    toJSON() {
        return this.value;
    }
    toString() {
        return this.value.toFixed(this.precision);
    }
    static create(value, precision = 0) {
        return new Fixed(value, precision).round();
    }
    static add(value, term, precision = 0) {
        return this.create(value, precision).add(term);
    }
    static subtract(value, minuend, precision = 0) {
        return this.create(value, precision).subtract(minuend);
    }
    static multiply(value, multiplicand, precision = 0) {
        return this.create(value, precision).multiply(multiplicand);
    }
    static divide(value, denominator, precision = 0) {
        return this.create(value, precision).divide(denominator);
    }
}
(function (Fixed) {
    Fixed.Precision = _Precision;
})(Fixed || (Fixed = {}));
//# sourceMappingURL=index.js.map